import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import ScrollAnimation from 'react-wow';
import Link from 'next/link';

export default class index extends Component {
    render() {
        return (
            <section className="mt-4 mb-4 pt-4 pb-sm-4">
                <Container>
                    <Row>
                        <Col className="text-center" md>
                            <ScrollAnimation animation='bounceInLeft'>
                                <img src={`${publicRuntimeConfig.staticFolder}/images/analytics-sec.png`} alt="analytics-sec" className="mt-sm-3 auto-width-c" />
                            </ScrollAnimation>
                        </Col>
                        <Col>
                            <ScrollAnimation animation='bounceInRight'>
                                <div className="mt-4 pt-4">
                                    <div className="count">01</div>
                                    <div className="talk-content count-sd pl-3">What we do?</div>
                                </div>
                                <div className="main-heading-home pt-2">Analytics</div>
                                <div className="main-content pt-1">
                                    We analyze. We predict. We optimize. With us, your data gives you meaningful information and actionable insights.
                                </div>
                                <Link href="/analytics-services" as="/analytics">
                                    <div className="talk-content explore mt-4">Explore
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/Path.svg`} alt="Path" className="ml-sm-1" />
                                    </div>
                                </Link>
                            </ScrollAnimation>
                        </Col>
                    </Row>
                </Container>
                <style>
                    {
                        `
                        body{
                            overflow-x: hidden
                        }
                        `
                    }
                </style>
            </section>
        )
    }
}
